import * as Immutable from 'immutable';
import React from 'react';
import classNames from 'classnames';
import { kebabCase } from 'lodash';

import DraggableElementCreationTool from '../../../../../../../element/dnd/DraggableElementCreationTool';
import ElementPresentational from '../../../../../../../element/ElementPresentational';

import { getScaledGrabOffset } from '../../../../../../../utils/dnd/dragAndDropUtils';
import { AIResponseElement } from '../../../../../../../../common/ai/aiConversationTypes';

import { ELEMENT_CREATION_SOURCES } from '../../../../../../../../common/elements/elementConstants';

import './AiAssistantPopupResultElement.scss';

const getElementScaledCustomDragOffset = () => ({ x: 0, y: 0 });

const getElementScaledGrabOffset = (props: any, monitor: any) => {
    const sourceClientOffset = monitor.getSourceClientOffset();
    const clientOffset = monitor.getClientOffset();

    return getScaledGrabOffset({ clientOffset, sourceClientOffset });
};

const getDefaultContent = ({ result }: { result: { content: any } }): { textContent: object } => ({
    ...result.content,
});

const AiAssistantPopupResultElement = (props: {
    result: AIResponseElement;
    currentBoardId: string;
    isDraggable?: boolean;
}): React.ReactElement => {
    const WrapperComponent = props.isDraggable
        ? DraggableElementCreationTool
        : ({ children }: { children: React.ReactElement }) => children;

    return (
        <div className={classNames('AiAssistantPopupResultElement', kebabCase(props.result.elementType))}>
            <WrapperComponent
                {...props}
                delayTouchStart={300}
                elementType={props.result.elementType}
                getDefaultContent={getDefaultContent}
                getElementScaledCustomDragOffset={getElementScaledCustomDragOffset}
                getElementScaledGrabOffset={getElementScaledGrabOffset}
                creationSource={ELEMENT_CREATION_SOURCES.AI_ASSISTANT}
                editOnCreate={false}
                selectOnCreate={false}
            >
                <ElementPresentational
                    element={Immutable.fromJS({
                        id: 'new-element',
                        ...props.result,
                    })}
                    gridSize={10}
                    inList="in-list-inbox"
                    isPresentational
                />
            </WrapperComponent>
        </div>
    );
};

export default AiAssistantPopupResultElement;
